import classes from './forgot-password.module.scss';
import { Alert, Button, Form, Input, Spin, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Wrapper } from '../../components/shared/wrapper.component';
import { MdMail } from 'react-icons/md';
import { IoArrowBackOutline } from 'react-icons/io5';
import useForgotPassword from '../../Hooks/forgot-password.hook';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { localizedPath } from '../../utils/localized-route';
import { useTranslation } from 'react-i18next';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const { requestResetPassword, onCaptchaVerify, state } = useForgotPassword();
  return (
    <Wrapper>
      <div className={classes.forgotPasswordContainer}>
        <div className={classes.textContainer}>
          <h1 className={classes.title}>{t('forgot-password.title')}</h1>
          <p className={classes.text}>{t('forgot-password.description')}</p>
        </div>
        <Form
          size="large"
          layout="vertical"
          name="forgot-password"
          onFinish={requestResetPassword}
          className={classes.forgotPasswordForm}
          scrollToFirstError
          disabled={state.loading}
          requiredMark={false}
        >
          <Form.Item
            className={classes.formItem}
            name="email"
            label={t('forgot-password.email-label')}
            rules={[
              {
                type: 'email',
                message: t('common.invalid-email'),
                whitespace: true,
              },
              {
                required: true,
                message: t('common.required'),
                whitespace: true,
              },
            ]}
          >
            <Input
              prefix={<MdMail color="grey" />}
              placeholder={t('common.email')}
              size="large"
              className={classes.inputField}
            />
          </Form.Item>
          <Form.Item>
            <Button
              className={classes.resetPasswordBtn}
              disabled={state.loading}
              type="primary"
              htmlType="submit"
            >
              {t('forgot-password.reset')}
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              icon={<IoArrowBackOutline />}
              className={classes.backBtn}
              disabled={state.loading}
              href={localizedPath('/login')}
            >
              {t('common.back-to-login')}
            </Button>
            <p className={classes.loginText}>
              {t('forgot-password.have-account')} &nbsp;
              <Typography.Link href={localizedPath('/register')}>{t('forgot-password.sign-up')}</Typography.Link>
            </p>
            {state.loading && (
              <Spin
                className={classes.feedback}
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              />
            )}
          </Form.Item>
          <GoogleReCaptcha
            onVerify={onCaptchaVerify}
          />
        </Form>
        {state.type === 'error' && (
          <Alert
            className={classes.feedback}
            showIcon
            message={
              Array.isArray(state.result?.message)
                ? state.result?.message.map((msg, id) => {
                  return <p key={id}>{msg}</p>;
                })
                : state.result?.message
            }
            type="error"
            closable
          />
        )}
        {state.type === 'success' && (
          <Alert
            className={classes.feedback}
            message={state.result?.message}
            showIcon
            type="success"
            closable
          />
        )}
      </div>
    </Wrapper>
  );
};

export default ForgotPassword;
